import { HashRouter, Routes, Route } from "react-router-dom";
import './App.css';
import MainRoutes from "./routes/mainroutes";

function App() {
  return (
    <HashRouter>
        <MainRoutes />
    </HashRouter>
  );
}

export default App;
